// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);
  
  	boostPFSInstantSearchConfig.search.suggestionMobileStyle = (Utils.isMobile() && Utils.isSearchPage()) ? 'style2': 'style1',

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {};
})();

// jQuery(document).ready(function(){
//   setTimeout(function(){
//     var template = jQuery('body').hasClass('template-search')
    
//     if(template == true) {
//       jQuery('.boost-pfs-search-suggestion-wrapper').addClass('hide-search')
//     }
//   }, 1000)
// })